// File: frontend/src/services/calendarService.js
// VERSION v1.41 (2025-10-30)
// Description:
// - [ИСПРАВЛЕНИЕ] Возвращено к v1.0 (возвращает `response` напрямую, а не `response.data`).
//   Это исправляет баг с пустым списком юристов (v1.40).
// - [ДОБАВЛЕНО] Добавлена `getFreeSlots` (используя `makeRequest`).

import apiService from './apiService';
import toast from 'react-hot-toast';

class CalendarService {

    /**
     * (v1.0)
     */
    async createAppointment(appointmentData) {
        try {
            const response = await apiService.makeRequest('/calendar/appointments', {
                method: 'POST',
                body: JSON.stringify(appointmentData),
            });
            toast.success('Appointment created successfully!');
            return response; // <--- ИСПРАВЛЕНО v1.41 (возвращаем response)
        } catch (error) {
            console.error('Error creating appointment:', error);
            toast.error(error.message || 'Failed to create appointment');
            throw error;
        }
    }

    /**
     * (v1.0)
     */
    async getWorkingHours() {
        try {
            const response = await apiService.makeRequest('/calendar/working-hours');
            return response; // <--- ИСПРАВЛЕНО v1.41 (возвращаем response)
        } catch (error) {
            console.error('Error fetching working hours:', error);
            return this.getDefaultWorkingHours();
        }
    }

    /**
     * (v1.0)
     */
    async updateWorkingHours(workingHoursData) {
        try {
            const response = await apiService.makeRequest('/calendar/working-hours', {
                method: 'PUT',
                body: JSON.stringify(workingHoursData),
            });
            toast.success('Working hours updated successfully!');
            return response; // <--- ИСПРАВЛЕНО v1.41 (возвращаем response)
        } catch (error) {
            console.error('Error updating working hours:', error);
            toast.error(error.message || 'Failed to update working hours');
            throw error;
        }
    }

    /**
     * (v1.0)
     */
    getDefaultWorkingHours() {
        return {
            monday: { start: '08:00', end: '18:00', isWorking: true },
            tuesday: { start: '08:00', end: '18:00', isWorking: true },
            wednesday: { start: '08:00', end: '18:00', isWorking: true },
            thursday: { start: '08:00', end: '18:00', isWorking: true },
            friday: { start: '08:00', end: '18:00', isWorking: true },
            saturday: { start: '08:00', end: '18:00', isWorking: false },
            sunday: { start: '08:00', end: '18:00', isWorking: false },
        };
    }

    /**
     * (v1.0) - Это исправляет баг "пустого списка"
     */
    async getAvailableAttorneys() {
        try {
            const response = await apiService.makeRequest('/users/by-role/ATTORNEY');
            // v1.0 (оригинал) возвращал `response`, и v1.38 `NewAppointmentModal.js` ожидает массив
            return response || []; // <--- ИСПРАВЛЕНО v1.41 (возвращаем response)
        } catch (error) {
            console.error('Error fetching attorneys:', error);
            toast.error('Failed to load attorneys');
            throw error;
        }
    }

    /**
     * (v1.0)
     */
    async checkAvailability(attorneyId, dateTimeStr, durationMinutes = 30) {
        try {
            const params = new URLSearchParams({
                attorney_id: attorneyId,
                datetime: dateTimeStr,
                duration_minutes: durationMinutes,
            });
            const response = await apiService.makeRequest(`/calendar/availability?${params.toString()}`);
            return response; // <--- ИСПРАВЛЕНО v1.41 (возвращаем response)
        } catch (error) {
            console.error('Error checking availability:', error);
            return { available: true };
        }
    }

    // --- [НОВАЯ ФУНКЦИЯ v1.41, на основе v1.35] ---
    /**
     * Получает массив свободных слотов
     */
    async getFreeSlots(attorneyId, dateStr) {
        console.log(`calendarService: Запрос /calendar/free-slots для attorneyId=${attorneyId}, date=${dateStr}`);
        try {
            const params = new URLSearchParams({
                attorney_user_ids: [attorneyId], // Бэкенд ожидает массив
                date_str: dateStr
            });
            // Используем makeRequest (v1.41)
            const response = await apiService.makeRequest(`/calendar/free-slots?${params.toString()}`);
            return response || []; // <--- ИСПРАВЛЕНО v1.41 (возвращаем response)
        } catch (error) {
            console.error("Error fetching free slots:", error);
            throw error; 
        }
    }
    // --- [КОНЕЦ v1.41] ---
}

export default new CalendarService();

